/**
 * enum for setting block alignment, used by setAlignment API
 */
export const enum Alignment {
    /**
     * Align left
     */
    Left,

    /**
     * Align center
     */
    Center,

    /**
     * Align right
     */
    Right,
}
